// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Restaumatic_Form_Action from "../Restaumatic.Form.Action/index.js";
import * as Restaumatic_Form_Delayed from "../Restaumatic.Form.Delayed/index.js";
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic_Form_Query from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic_Form_Result from "../Restaumatic.Form.Result/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Form_Undoable_History from "../Restaumatic.Form.Undoable.History/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_AnnEquality from "../Type.AnnEquality/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var toRecordHelperRecord = /* #__PURE__ */ Restaumatic_Form_TestHelpers.toRecordHelperRecord()(/* #__PURE__ */ Restaumatic_Form_TestHelpers.recordToHelperCons({
    reflectSymbol: function () {
        return "redo";
    }
})(Restaumatic_Form_TestHelpers.toHelperAction)(/* #__PURE__ */ Restaumatic_Form_TestHelpers.recordToHelperCons({
    reflectSymbol: function () {
        return "undo";
    }
})(Restaumatic_Form_TestHelpers.toHelperAction)(Restaumatic_Form_TestHelpers.recordToHelperNil)));
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Base.bindDynamic);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var pure = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var read = /* #__PURE__ */ Specular_Ref.read(Effect_Class.monadEffectEffect);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var write = /* #__PURE__ */ Specular_Ref.write(Effect_Class.monadEffectEffect);
var bind2 = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Host.bindHost);
var $$new = /* #__PURE__ */ Specular_Ref["new"](Specular_FRP_Host.monadEffectHost);
var discard2 = /* #__PURE__ */ discard(Specular_FRP_Host.bindHost);
var subscribeDyn_ = /* #__PURE__ */ Specular_FRP_Base.subscribeDyn_(/* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_FRP_Host.monadEffectHost)(Specular_FRP_Host.monadCleanupHost));
var modify = /* #__PURE__ */ Specular_Ref.modify(Effect_Class.monadEffectEffect);
var fixDelayed = /* #__PURE__ */ Restaumatic_Form_Delayed.fixDelayed(Specular_FRP_Host.monadEffectHost);
var makeImpl = /* #__PURE__ */ Restaumatic_Form_Internal.makeImpl(/* #__PURE__ */ Restaumatic_Form_Action.initializeNoInitialValueA1(Type_AnnEquality.annTypeEquals));
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Host.applicativeHost);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var Undoable = function (x) {
    return x;
};
var undoableLikeUndoable = {
    withUndoableD: function (field) {
        return function (f) {
            return f(field);
        };
    }
};
var toRecordHelperUndoable = function (dictToRecordHelper) {
    var toHelperClassBody = Restaumatic_Form_TestHelpers.toHelperClassBody(Restaumatic_Form_TestHelpers.toRecordHelperWithExtra(dictToRecordHelper)(toRecordHelperRecord));
    return {
        helperBaseClass: function (v) {
            return Data_Maybe.Nothing.value;
        },
        toHelperClassBody: function (v) {
            return toHelperClassBody(Type_Proxy["Proxy"].value);
        },
        ToHelper0: function () {
            return toHelperUndoable(dictToRecordHelper);
        }
    };
};
var toHelperUndoable = function (dictToRecordHelper) {
    var fillFormFieldType = Restaumatic_Form_TestHelpers.fillFormFieldType(Restaumatic_Form_TestHelpers.toHelperWithExtra(dictToRecordHelper)(toRecordHelperRecord));
    return {
        fillFormFieldType: function (v) {
            return fillFormFieldType(Type_Proxy["Proxy"].value);
        },
        toHelperConstructor: function (p) {
            return Restaumatic_Form_TestHelpers.toRecordHelperConstructor(toRecordHelperUndoable(dictToRecordHelper))(p);
        }
    };
};
var queryUndoable = function (dictQuery) {
    var queryImpl = Restaumatic_Form_Query.queryImpl(dictQuery);
    return {
        queryImpl: function (s) {
            return function (v) {
                return queryImpl(s)(v.subform);
            };
        }
    };
};
var mergeUndoable = function (dictMerge) {
    var merge = Restaumatic_Form_Internal.merge(dictMerge);
    return {
        merge: function (a) {
            return function (v) {
                return merge(a)(v.subform);
            };
        }
    };
};
var hasFieldUndoable = function (dictHasField) {
    var getField = Data_Record.getField(dictHasField);
    return {
        getField: function (label) {
            return function (v) {
                return getField(label)(v.subform);
            };
        }
    };
};
var hasField$34undo$34Action_Undo = {
    getField: function (v) {
        return function (v1) {
            return v1.undo;
        };
    }
};
var hasField$34redo$34Action_Undo = {
    getField: function (v) {
        return function (v1) {
            return v1.redo;
        };
    }
};
var addContextUndoable = function (dictAddContext) {
    var addContext = Restaumatic_Form_Internal.addContext(dictAddContext);
    return {
        addContext: function (ctx) {
            return function (v) {
                return addContext(ctx)(v.subform);
            };
        }
    };
};
var withUndoableD = function (dict) {
    return dict.withUndoableD;
};
var undoableLikeDelayed = function (dictUndoableLike) {
    var withUndoableD1 = withUndoableD(dictUndoableLike);
    return {
        withUndoableD: function (v) {
            return function (f) {
                return bind(v)(function (u) {
                    return withUndoableD1(u)(f);
                });
            };
        }
    };
};
var undoableLikeDelayed1 = /* #__PURE__ */ undoableLikeDelayed(undoableLikeUndoable);
var toUndoableE = function (dictUndoableLike) {
    var withUndoableD1 = withUndoableD(dictUndoableLike);
    return function (u) {
        return readDynamic(withUndoableD1(u)(pure));
    };
};
var undo = function (dictUndoableLike) {
    var toUndoableE1 = toUndoableE(dictUndoableLike);
    return function (dictMerge) {
        var merge = Restaumatic_Form_Internal.merge(dictMerge);
        return function (u) {
            return function __do() {
                var v = toUndoableE1(u)();
                var h0 = read(v.history)();
                return for_(Restaumatic_Form_Undoable_History.undo(h0))(function (v1) {
                    return function __do() {
                        merge(v1.value0)(v.subform)();
                        return write(v.history)(v1.value1)();
                    };
                })();
            };
        };
    };
};
var undo1 = /* #__PURE__ */ undo(undoableLikeDelayed1);
var subform = function (v) {
    return v.subform;
};
var redo = function (dictUndoableLike) {
    var toUndoableE1 = toUndoableE(dictUndoableLike);
    return function (dictMerge) {
        var merge = Restaumatic_Form_Internal.merge(dictMerge);
        return function (u) {
            return function __do() {
                var v = toUndoableE1(u)();
                var h0 = read(v.history)();
                return for_(Restaumatic_Form_Undoable_History.redo(h0))(function (v1) {
                    return function __do() {
                        merge(v1.value0)(v.subform)();
                        return write(v.history)(v1.value1)();
                    };
                })();
            };
        };
    };
};
var redo1 = /* #__PURE__ */ redo(undoableLikeDelayed1);
var initializeUndoable = function (dictInitialize) {
    var makeImpl1 = Restaumatic_Form_Internal.makeImpl(dictInitialize);
    return function (dictQuery) {
        var queryLax = Restaumatic_Form_Query.queryLax(dictQuery);
        return function (dictMerge) {
            var undo2 = undo1(dictMerge);
            var redo2 = redo1(dictMerge);
            return function (dictEq) {
                var change = Restaumatic_Form_Undoable_History.change(dictEq);
                return {
                    makeImpl: function (s) {
                        return function (opts) {
                            return function (meta) {
                                return function (iv) {
                                    return function (initializer) {
                                        return bind2(makeImpl1(s)(opts)(meta)(iv)(initializer))(function (sub) {
                                            return bind2($$new(Restaumatic_Form_Undoable_History.empty))(function (history_) {
                                                return discard2(Restaumatic_Form_Delayed.afterInitialized(Data_Function.flip(subscribeDyn_)(Restaumatic_Form_DynamicResult.unwrap(queryLax(sub)))(function (a) {
                                                    return for_(Restaumatic_Form_Result.toMaybe(a))(function (a$prime) {
                                                        return modify(history_)(change(a$prime));
                                                    });
                                                })))(function () {
                                                    return fixDelayed(function (self) {
                                                        return bind2(makeImpl(s)({
                                                            name: append(opts.name)([ "undo" ])
                                                        })(meta)(Restaumatic_Form_Internal.NoInitialValue.value)(undo2(self)))(function (undoAction) {
                                                            return bind2(makeImpl(s)({
                                                                name: append(opts.name)([ "redo" ])
                                                            })(meta)(Restaumatic_Form_Internal.NoInitialValue.value)(redo2(self)))(function (redoAction) {
                                                                return pure1({
                                                                    subform: sub,
                                                                    history: history_,
                                                                    undo: undoAction,
                                                                    redo: redoAction
                                                                });
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    };
                                };
                            };
                        };
                    }
                };
            };
        };
    };
};
var cleanHistory = function (dictUndoableLike) {
    var toUndoableE1 = toUndoableE(dictUndoableLike);
    return function (dictMerge) {
        return function (u) {
            return function __do() {
                var v = toUndoableE1(u)();
                return write(v.history)(Restaumatic_Form_Undoable_History.empty)();
            };
        };
    };
};
var canUndo = function (dictUndoableLike) {
    var withUndoableD1 = withUndoableD(dictUndoableLike);
    return function (u) {
        return withUndoableD1(u)(function (v) {
            return map(Restaumatic_Form_Undoable_History.canUndo)(Specular_Ref.value(v.history));
        });
    };
};
var canRedo = function (dictUndoableLike) {
    var withUndoableD1 = withUndoableD(dictUndoableLike);
    return function (u) {
        return withUndoableD1(u)(function (v) {
            return map(Restaumatic_Form_Undoable_History.canRedo)(Specular_Ref.value(v.history));
        });
    };
};
export {
    withUndoableD,
    Undoable,
    toUndoableE,
    canUndo,
    canRedo,
    undo,
    redo,
    cleanHistory,
    subform,
    initializeUndoable,
    queryUndoable,
    mergeUndoable,
    addContextUndoable,
    hasField$34undo$34Action_Undo,
    hasField$34redo$34Action_Undo,
    hasFieldUndoable,
    undoableLikeUndoable,
    undoableLikeDelayed,
    toHelperUndoable,
    toRecordHelperUndoable
};
